import client from "./client";

// Returns the full user directory. Used to resolve author names/emails for
// posts, community members, chat messages and admin tooling.
export const getUsers = () => client.get("/users");

// Fetches one specific user — use this instead of getUsers() + a
// client-side .find() when only one profile is actually needed.
export const getUser = (id) => client.get(`/users/${id}`);

export const getCommunityMembers = (communityId) =>
  client.get(`/communities/members/${communityId}`);

// Updates a user's core account fields (name, email, phone, birthday) —
// separate from the bio/portfolio fields, which go through api/bios.js.
export const updateUserInfo = (id, data) => client.patch(`/users/update/${id}`, data);

export const changePassword = (currentPassword, newPassword) =>
  client.post("/users/change-password", { currentPassword, newPassword });
